import React, { useContext, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import axios from 'axios'
import './AuthForm.scss'
import UserContext from '../../context/UserContext';
import ErrorMessage from '../misc/ErrorMessage';
import domain from '../../util/domain'

function Register() {
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [passwordVerification, setPasswordVerification] = useState();
    const [errorMessage, setErrorMessage] = useState(null);
    const {getUser} = useContext(UserContext);
    const history = useHistory();

    async function register(e) {
        e.preventDefault();
        const registerData = { email, password, passwordVerification }
        try {
        await axios.post(`${domain}/auth/`, registerData)
        } catch (err) {
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
            return
        }

        await getUser()
        history.push('/')
    }

    return (
        <div className="auth-form">
            <h2>Register a new account</h2>
            {errorMessage && <ErrorMessage message={errorMessage} clear={() => setErrorMessage(null)}/>}
            <form className="form" onSubmit={register}>
                <label htmlFor="email">Email</label>
                <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                <label htmlFor="password">Password</label>
                <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <label htmlFor="password-verification">Verify password</label>
                <input id="password-verification" type="password" value={passwordVerification} onChange={(e) => setPasswordVerification(e.target.value)} />
                <button className="btn-submit-auth" type="submit">Register</button>
            </form>
            <p>Already have an account? <Link to='/login'>Login instead</Link></p>
        </div>
    )
}

export default Register
